var Component = require("!./../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!./../vue-loader/lib/template-compiler?id=data-v-44f96aae!./../vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/swiper.vue
// module id = 144
// module chunks = 1